import { NgModule } from '@angular/core';

import { DdvWidgetService } from './services/ddv-widget.service';
import { WidgetOnBoardService } from './services/widget-on-board.service';

@NgModule({
    providers: [
        DdvWidgetService,
        WidgetOnBoardService,
    ],
})
export class WidgetOnBoardsModule {}
